var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-file',_vm._g(_vm._b({scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._t("default",null,{"loading":_vm.uploading},props)]}}],null,true)},'base-file',_vm.$attrs,false),_vm.computedListeners))
}
var staticRenderFns = []

export { render, staticRenderFns }